var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "dashboardRef", staticClass: "data-views" }, [
    _c("div", { staticClass: "data-views-div" }, [
      _c("div", { staticClass: "data-views-header" }, [
        _c("div", { staticClass: "data-views-title" }, [
          _vm._v("共青团广西区委网络舆情监控")
        ]),
        _c("div", { staticClass: "header-date" }, [
          _c("div", { staticClass: "header-date-time" }, [
            _vm._v(" " + _vm._s(_vm.currentTime) + " ")
          ]),
          _c("div", [
            _c("div", [_vm._v(_vm._s(_vm.currentDayOfWeek))]),
            _c("div", [_vm._v(_vm._s(_vm.currentDate))])
          ])
        ])
      ]),
      _c("div", { staticClass: "data-views-main-content" }, [
        _c("div", { staticClass: "ch2-view-main" }, [
          _c("div", { staticClass: "main-top flex-1" }, [
            _c("div", { staticClass: "main-top-left flex-2" }, [
              _c("div", { staticClass: "public-sentiment-one" }, [
                _c("div", { ref: "countsRef", staticClass: "ch2-counts" }, [
                  _c("div", { staticClass: "ai-card" }, [
                    _c("div", { staticClass: "ai-card-inner" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/ai-base-icon.png"),
                          alt: ""
                        }
                      }),
                      _c("div", [
                        _c("div", { staticClass: "ai-card-value" }, [
                          _vm._v(_vm._s(_vm.frontTotalCount))
                        ]),
                        _c("div", { staticClass: "ai-card-label" }, [
                          _vm._v("正面报道")
                        ])
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "ai-card" }, [
                    _c("div", { staticClass: "ai-card-inner" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/ai-base-icon.png"),
                          alt: ""
                        }
                      }),
                      _c("div", [
                        _c("div", { staticClass: "ai-card-value" }, [
                          _vm._v(_vm._s(_vm.negativeTotalCount))
                        ]),
                        _c("div", { staticClass: "ai-card-label" }, [
                          _vm._v("网络舆情")
                        ])
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "ai-card" }, [
                    _c("div", { staticClass: "ai-card-inner" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/ai-base-icon.png"),
                          alt: ""
                        }
                      }),
                      _c("div", [
                        _c("div", { staticClass: "ai-card-value" }, [
                          _vm._v(_vm._s(_vm.toDayData.length))
                        ]),
                        _c("div", { staticClass: "ai-card-label" }, [
                          _vm._v("今日舆情")
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "flex-1 flex ch2-left-bottom" }, [
                _c(
                  "div",
                  { staticStyle: { height: "100%", width: "100%" } },
                  [
                    _c("div", { staticClass: "subtitle" }, [
                      _c(
                        "div",
                        { staticClass: "subtitle-top justif-between" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-center" },
                            [
                              _c("IconSvg"),
                              _c("span", { staticClass: "subtitle-text" }, [
                                _vm._v("舆情趋势统计")
                              ])
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "padding-right": "16px"
                              }
                            },
                            [
                              _c("a-range-picker", {
                                staticClass: "ch2-date-input",
                                staticStyle: { width: "200px" },
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.dateValues,
                                  callback: function($$v) {
                                    _vm.dateValues = $$v
                                  },
                                  expression: "dateValues"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._m(0)
                    ]),
                    _c("TrendChart", {
                      ref: "trendChartRef",
                      attrs: { dateRange: _vm.dateValues }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("div", { staticClass: "main-top-right flex-1" }, [
              _c(
                "div",
                { staticClass: "public-sentiment-two training-course-item" },
                [
                  _c("div", { staticStyle: { height: "100%" } }, [
                    _c("div", { staticClass: "subtitle" }, [
                      _c(
                        "div",
                        { staticClass: "subtitle-top" },
                        [
                          _c("IconSvg"),
                          _c("span", { staticClass: "subtitle-text" }, [
                            _vm._v("今日舆情")
                          ])
                        ],
                        1
                      ),
                      _vm._m(1)
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "ch2-list",
                        staticStyle: { "max-height": "380px" }
                      },
                      [
                        _vm.toDayData.length
                          ? _c("ScrollBoard", {
                              attrs: { data: _vm.toDayData, height: 380 },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var record = ref.record
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "alert-item" },
                                          [
                                            _c(
                                              "a-popover",
                                              { attrs: { title: "内容摘要" } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "content" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "1.2rem",
                                                          width: "500px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            record.ContentSummary
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-ellipsis title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        record.ContentSummary
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "date" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      record.CreationTime
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "triangle"
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4112369125
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "main-bottom" }, [
            _c(
              "div",
              {
                staticClass: "flex-1",
                staticStyle: { height: "100%", width: "100%" }
              },
              [
                _c("div", { staticClass: "subtitle" }, [
                  _c(
                    "div",
                    { staticClass: "subtitle-top" },
                    [
                      _c("IconSvg"),
                      _c("span", { staticClass: "subtitle-text" }, [
                        _vm._v("正面报道")
                      ])
                    ],
                    1
                  ),
                  _vm._m(2)
                ]),
                _c(
                  "div",
                  {
                    staticClass: "ch2-list",
                    staticStyle: { "max-height": "380px" }
                  },
                  [
                    _vm.frontData.length
                      ? _c("ScrollBoard", {
                          attrs: { data: _vm.frontData, height: 380 },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var record = ref.record
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "alert-item" },
                                      [
                                        _c(
                                          "a-popover",
                                          { attrs: { title: "内容摘要" } },
                                          [
                                            _c(
                                              "template",
                                              { slot: "content" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "1.2rem",
                                                      width: "500px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        record.ContentSummary
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-ellipsis title"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(record.ContentSummary)
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _c("span", { staticClass: "date" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("date")(
                                                record.CreationTime
                                              )
                                            )
                                          )
                                        ]),
                                        _c("div", {
                                          staticClass: "triangle",
                                          staticStyle: {
                                            "border-left-color": "#1890ff"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3473900585
                          )
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _c("div", { staticClass: "flex-1 flex" }, [
              _c(
                "div",
                { staticClass: "flex-1", staticStyle: { height: "100%" } },
                [
                  _c("div", { staticClass: "subtitle" }, [
                    _c(
                      "div",
                      { staticClass: "subtitle-top" },
                      [
                        _c("IconSvg"),
                        _c("span", { staticClass: "subtitle-text" }, [
                          _vm._v("网络舆情")
                        ])
                      ],
                      1
                    ),
                    _vm._m(3)
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "ch2-list",
                      staticStyle: { "max-height": "380px" }
                    },
                    [
                      _vm.negativeData.length
                        ? _c("ScrollBoard", {
                            attrs: { data: _vm.negativeData, height: 380 },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var record = ref.record
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "alert-item" },
                                        [
                                          _c(
                                            "a-popover",
                                            { attrs: { title: "内容摘要" } },
                                            [
                                              _c(
                                                "template",
                                                { slot: "content" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "1.2rem",
                                                        width: "500px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          record.ContentSummary
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-ellipsis title"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      record.ContentSummary
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _c("span", { staticClass: "date" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  record.CreationTime
                                                )
                                              )
                                            )
                                          ]),
                                          _c("div", {
                                            staticClass: "triangle",
                                            staticStyle: {
                                              "border-left-color": "#ff4d4f"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              759919147
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtitle-underline" }, [
      _c("div", { staticClass: "left-underline" }),
      _c("div", { staticClass: "right-underline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtitle-underline" }, [
      _c("div", { staticClass: "left-underline" }),
      _c("div", { staticClass: "right-underline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtitle-underline" }, [
      _c("div", { staticClass: "left-underline" }),
      _c("div", { staticClass: "right-underline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtitle-underline" }, [
      _c("div", { staticClass: "left-underline" }),
      _c("div", { staticClass: "right-underline" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }